import { Navigate, BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import PivotboxLandingPage from "@/pages/PivotboxLandingPage";
import LegalDocumentPage from "@/pages/LegalDocumentPage";
import S0ReportPage from "@/pages/S0ReportPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import FiveSFrameworkPage from "@/pages/FiveSFrameworkPage";
import S1DiagnosticPage from "@/pages/S1DiagnosticPage";
import S0DiagnosticPage from "@/pages/sdiag/S0DiagnosticPage";
import S21DiagnosticPage from "@/pages/sdiag/S21DiagnosticPage";
import S22DiagnosticPage from "@/pages/sdiag/S22DiagnosticPage";
import S23DiagnosticPage from "@/pages/sdiag/S23DiagnosticPage";
import CanvasLandingPage from "@/pages/canvasLandings/CanvasLandingPage";
import { s3Data, s4Data } from "@/pages/canvasLandings/canvasLandingData";
import TestPayRs1Page from "@/pages/TestPayRs1Page";
import FreeDiagnosticPage from "@/pages/FreeDiagnosticPage";
import FounderSignalTestPage from "@/pages/FounderSignalTestPage";
import WhatsAppFloatingButton from "@/components/pivotbox/WhatsAppFloatingButton";
import ScrollToTop from "@/components/pivotbox/ScrollToTop";
import { trackInitiateAssessment } from "@/components/pivotbox/metaPixel";

function App() {
  // Meta Pixel: fire `InitiateAssessment` on any click that targets the
  // Founder Signal Assessment — new route /foundersignaltest, or any
  // remaining #founder-signal-test hash link (legacy/backward-compat).
  // GA4 `generate_lead` is fired at S0 completion (on /s0-report/:id) instead.
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.includes("/foundersignaltest") || href.includes("#founder-signal-test")) {
        trackInitiateAssessment();
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PivotboxLandingPage />} />
          <Route path="/discover-your-pivot" element={<PivotboxLandingPage />} />
          <Route path="/s0-report/:reportId" element={<S0ReportPage />} />
          <Route path="/diagnostic" element={<DiagnosticPage />} />
          <Route path="/find-out" element={<FiveSFrameworkPage />} />
          <Route path="/s1diagnostic" element={<S1DiagnosticPage />} />
          <Route path="/S0diagnostic" element={<S0DiagnosticPage />} />
          <Route path="/s0diagnostic" element={<S0DiagnosticPage />} />
          <Route path="/S21diagnostic" element={<S21DiagnosticPage />} />
          <Route path="/s21diagnostic" element={<S21DiagnosticPage />} />
          <Route path="/S22diagnostic" element={<S22DiagnosticPage />} />
          <Route path="/s22diagnostic" element={<S22DiagnosticPage />} />
          <Route path="/S23diagnostic" element={<S23DiagnosticPage />} />
          <Route path="/s23diagnostic" element={<S23DiagnosticPage />} />
          <Route path="/privacy-policy" element={<LegalDocumentPage pageKey="privacy" />} />
          <Route path="/terms-of-use" element={<LegalDocumentPage pageKey="terms" />} />
          <Route path="/terms-and-conditions" element={<LegalDocumentPage pageKey="terms" />} />
          <Route path="/disclaimer" element={<LegalDocumentPage pageKey="disclaimer" />} />
          <Route path="/refund-policy" element={<LegalDocumentPage pageKey="refund" />} />
          <Route path="/strategyblueprint" element={<CanvasLandingPage data={s3Data} />} />
          <Route path="/founderoperatingsystem" element={<CanvasLandingPage data={s4Data} />} />
          <Route path="/test-pay-rs1" element={<TestPayRs1Page />} />
          <Route path="/freediagnostic" element={<FreeDiagnosticPage />} />
          <Route path="/foundersignaltest" element={<FounderSignalTestPage />} />
          <Route path="/founder-signal-test" element={<FounderSignalTestPage />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            className: "pivotbox-toast",
          }}
        />
        <WhatsAppFloatingButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
